import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const labels = {
  "/learning-center": "Learning Center",
  "/training-center": "Training Center",
  "/marinas": "Marina Directory",
  "/weather": "Marine Weather",
  "/premium": "Premium Tools",
  "/port-entry": "Port Entry Pack",
  "/routes": "Route Library",
  "/regulations": "Regulations Center",
  "/safety": "Safety Center",
  "/contact": "Contact",
  "/skipper-tools": "Skipper Tools",
  };

export default function PublicSeoRelated({ links }) {
  return (
    <section className="rounded-3xl border border-primary/20 bg-primary/5 p-6 md:p-8">
      <h2 className="font-heading text-2xl font-bold">Continue Planning</h2>
      <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {links.map((href) => (
          <Link
            key={href}
            to={href}
            className="group flex items-center justify-between rounded-2xl border border-border bg-card px-4 py-3 text-sm font-semibold transition-colors hover:border-primary/40 hover:text-primary"
          >
            <span>{labels[href] || href}</span>
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Link>
        ))}
      </div>
    </section>
  );
}